import _ from '@lodash';
import { makeStyles, useTheme, ThemeProvider } from '@material-ui/core/styles';
import { Button, Icon, TextField } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import VizsgaFeladatsorService from '../service/VizsgaFeladatsorService';

const useStyles = makeStyles(theme => ({
	checkResultContainer: {
		padding: '18.5px 14px',
		borderRadius: '4px',
		borderWidth: '1px',
		borderColor: theme.palette.divider,
		height: '357px'
	},
	checkResultContainerWrap: {
		height: '100%',
		overflowY: 'scroll'
	},
	checkResultItem: {
		lineHeight: '1.15'
	},
	checkResultValid: {
		backgroundColor: '#00ff00',
		width: '12px',
		height: '12px'
	},
	checkResultInvalid: {
		backgroundColor: '#ff0000',
		width: '12px',
		height: '12px'
	},
	textAreaStyle: {
		lineHeight: '1.15'
	}
}));

function EditFormFeladatsorField(props) {
	const classes = useStyles(props);
	const theme = useTheme();

	const { error } = props.fieldState;
	const { value, onChange } = props.field;
	const methods = useFormContext();
	const { watch } = methods;
	const workbookId = watch(props.fieldConfig.workbookIdField);
	const [checkResult, setCheckResult] = useState([]);
	const [resultMsg, setResultMsg] = useState(null);

	const [textAreaValue, setTextAreaValue] = useState('');
	const [readOnly, setReadOnly] = useState(props.fieldConfig.readOnly || false);
	props.config.editableAccess === 'Restricted' && _.isArray(props.config.editableFields) && !props.config.editableFields.includes(props.fieldConfig.key) && !readOnly ? setReadOnly(true) : null;

	const handleCheck = () => {
		const inputArray = textAreaValue.match(/[^\r\n]+/g);
		const inputResult = inputArray.filter(item => item && item.length > 0);
		setTextAreaValue(inputResult.join('\r\n'));
		VizsgaFeladatsorService.checkQuestions(inputResult, workbookId).then(resp => {
			const correctValues = resp.filter(item => item.count === 1).map(item => item.id);
			onChange(correctValues);
			setCheckResult(resp);
			if (resp !== null && resp.length > 0) {
				const questionCount = resp.length;
				const correctQuestionCount = correctValues.length;
				setResultMsg(`A lista ${questionCount} kérdést tartalmaz, ebből ${correctQuestionCount} megfelelő, és ${questionCount - correctQuestionCount} hibás.`);
			} else {
				setResultMsg(null);
			}
		});
	};

	return (
		<div>
			<div className="mt-8 mb-16 text-center">
				<Button className="whitespace-nowrap" variant="contained" color="secondary" onClick={() => handleCheck()} startIcon={<Icon className="hidden sm:flex">check</Icon>}>
					Ellenőrzés
				</Button>
				{resultMsg !== null ? <p className="mt-16">{resultMsg}</p> : null}
			</div>
			<div className="grid grid-cols-2 gap-24">
				<TextField
					className="mt-8 mb-16"
					type={props.fieldConfig.type ? props.fieldConfig.type : 'text'}
					error={error}
					required={props.fieldConfig.required}
					helperText={error ? error.message : props.fieldConfig.helperText}
					label={props.fieldConfig.text}
					id={props.field.name}
					variant="outlined"
					fullWidth
					multiline
					inputProps={{ readOnly, className: clsx(classes.textAreaStyle) }}
					value={textAreaValue}
					onChange={e => setTextAreaValue(e.target.value)}
					rowsMax="20"
				/>
				{checkResult && checkResult.length > 0 ? (
					<div className={clsx('mt-8 mb-16', classes.checkResultContainer)}>
						<div className={clsx(classes.checkResultContainerWrap)}>
							{checkResult.map((item, i) => (
								<div key={i} className={clsx('grid grid-cols-3 gap-12', classes.checkResultItem)}>
									<div>{item.idText}</div>
									<div>
										<div className={clsx(item.count !== 1 ? classes.checkResultInvalid : classes.checkResultValid)} />
									</div>
									<div>{item.count !== 1 ? `count: ${item.count} Adat hiba!` : ``}</div>
								</div>
							))}
						</div>
					</div>
				) : null}
			</div>
		</div>
	);
}

export default EditFormFeladatsorField;
